module.exports = __webpack_public_path__ + "static/media/animal_02_big.542a906e.png";